import React, {useEffect,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';
import './AccountReminder.css';

const seenKey='sports-hq-account-benefit-seen';
const pendingKey='sports-hq-account-benefit-pending';

export default function AccountReminder(){
  const location=useLocation();
  const [visible,setVisible]=useState(false);
  const panel=useRef(null);
  useEffect(()=>{
    let timer,observer;
    const stop=()=>{clearTimeout(timer);observer?.disconnect();observer=null;};
    const check=()=>{
      const settings=window.SportsHQSettings;
      if(!settings?.sessionKnown || settings.authenticated){stop();setVisible(false);return;}
      try{
        if(!window.SportsHQAccountVisit?.returning || localStorage.getItem(seenKey) || sessionStorage.getItem(pendingKey)!=='1'){stop();return;}
        if(document.hidden || document.querySelector('.league-options,dialog[open],[aria-modal="true"]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]'))return;
        // A failed durable marker suppresses the reminder rather than nagging
        // again on every navigation in a storage-restricted browser.
        localStorage.setItem(seenKey,'1');sessionStorage.removeItem(pendingKey);
        stop();setVisible(true);
      }catch{stop();}
    };
    const schedule=()=>{clearTimeout(timer);timer=setTimeout(check,180);};
    const arm=()=>{
      try{
        if(!window.SportsHQSettings?.sessionKnown){setVisible(false);stop();return;}
        if(window.SportsHQSettings?.authenticated){sessionStorage.removeItem(pendingKey);setVisible(false);stop();return;}
        if(sessionStorage.getItem(pendingKey)!=='1' || localStorage.getItem(seenKey))return;
        if(!observer){observer=new MutationObserver(schedule);observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-expanded']});}
        schedule();
      }catch{}
    };
    window.addEventListener('sports-hq-account-benefit-ready',arm);
    window.addEventListener('sports-hq-settings-state',arm);
    const seenElsewhere=event=>{if(event.key===seenKey && event.newValue){setVisible(false);stop();}};
    window.addEventListener('storage',seenElsewhere);
    document.addEventListener('focusout',schedule);
    document.addEventListener('visibilitychange',arm);
    arm();
    return ()=>{stop();window.removeEventListener('sports-hq-account-benefit-ready',arm);window.removeEventListener('sports-hq-settings-state',arm);window.removeEventListener('storage',seenElsewhere);document.removeEventListener('focusout',schedule);document.removeEventListener('visibilitychange',arm);};
  },[location.pathname]);
  if(!visible)return null;
  const path=window.location.pathname.replace(/^\/(matches|floorball|hockey|football)$/, '/$1/');
  const href='/profile/?'+new URLSearchParams({login:'1',return:path+location.search});
  return <aside ref={panel} className="shq-account-reminder" aria-label="Spara dina val med ett konto">
    <strong>Ta med dina val</strong>
    <p>Med konto följer dina serier, lag du följer och inställningar med till andra enheter.</p>
    <div><a href={href}>Logga in</a><button type="button" onClick={()=>{const trigger=panel.current?.closest('main, .match-list-container')?.querySelector('.league-dropdown__trigger');setVisible(false);trigger?.focus({preventScroll:true});}}>Inte nu</button></div>
  </aside>;
}
